import maxLength from '../../../form/field-validation/max-length';

export const lengthAddressee = length => maxLength(length, 'name');
export const lengthAddress = length => maxLength(length, 'address');
export const lengthCompany = length => maxLength(length, 'company');
export const lengthHouseNumber = length => maxLength(length, 'houseNumber');
export const lengthPostCode = length => maxLength(length, 'postcode');
export const lengthAddressNickname = length => maxLength(length, 'addressNickname');

export const lengthField = length => maxLength(length);
